import React from 'react'
import {
  Button,
  Text,
  Heading,
  Container,
  Row,
  Column,
  Icon,
} from '@football-australia/ui-core'
import { useTheme } from '@emotion/react'
import { ProductTheme } from '@football-australia/ui-core/src'

export const Fallback: React.FC = () => {
  const theme = useTheme() as ProductTheme | null

  return (
    <Container
      direction="column"
      fullWidth
      fullHeight
      align="center"
      justify="center"
      gap="xl"
      maxWidth={512}
    >
      <Container fullHeight={false} maxWidth={512} gap={'xl'}>
        <Row gap={'md'}>
          <Column justify="center">
            <Icon
              name="wrench-screwdriver"
              size="xl"
              color={theme?.label.colors.secondary}
            />
          </Column>
        </Row>
        <Row gap="md">
          <Column>
            <Heading
              align="center"
              gutterBottom={true}
              color={theme?.label.colors.primary}
            >
              System Under Maintenance
            </Heading>
            <Text align="center" color={theme?.label.colors.secondary}>
              PlayFootball is currently under maintenance, Please refer to our
              Play Football Status page for more detail.
            </Text>
          </Column>
        </Row>
        <Row gap="md">
          <Column justify={{ xs: 'center' }}>
            <Button
              href="https://status.playfootball.com.au/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Play Football Status Page
            </Button>
          </Column>
          <Column justify={{ xs: 'center' }}>
            <Button
              href="https://support.playfootball.com.au/support/home"
              target="_blank"
              rel="noopener noreferrer"
              variant="text"
            >
              Help Centre & Support
            </Button>
          </Column>
        </Row>
      </Container>
    </Container>
  )
}
